import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceLetterheadManager } from "@/components/settings/workspace-letterhead-manager";

export const Route = createFileRoute("/_workspace/settings/letterheads")({
  component: SettingsLetterheadsPage,
});

function SettingsLetterheadsPage() {
  return (
    <section className="flex flex-col gap-6">
      <div className="flex flex-col gap-1">
        <h2 className="text-lg font-semibold">Letterheads</h2>
        <p className="text-sm text-muted-foreground">
          Design the header and footer that frame your generated documents. Pick your default in{" "}
          <span className="font-medium">Company</span> settings; teammates can override it per
          document.
        </p>
      </div>
      <WorkspaceLetterheadManager />
    </section>
  );
}
